import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Success from './Success'
import Body from './Body'

const Recharge = ({
  success,
  rechargePoints,
  handleRechargePoints,
  rechargeCredits,
  handleRechargeCredits,
  handlePointsConversion,
  accessToken,
  balance,
  handleAlert,
  transactionId,
  intervalObservable,
  handleIntervalObservable,
  handleDisabledConfirmButton,
  handleLoadingConfirmButton
}) => {
  return (
    <div className='p-2 position-relative'>
      <div className='col-12 flex-column mt-md-2 p-0'>
        <div className='col-12 p-0'>
          {success ? (
            <Fragment>
              <h2>Recarga concluída</h2>
              <p className='my-2 col-12 p-0'>
                Acompanhe todos os detalhes da sua solicitação
              </p>
            </Fragment>
          ) : (
            <Fragment>
              <h2>Faça uma recarga</h2>
              <p className='my-2 col-md-5 col-12 p-0'>
                Realize uma recarga para aproveitar o seu cartão em lojas
                físicas e na internet.
              </p>
            </Fragment>
          )}
        </div>
        {success ? (
          <Success
            rechargePoints={rechargePoints}
            rechargeCredits={rechargeCredits}
            transactionId={transactionId}
          />
        ) : (
          <Body
            handleRechargePoints={handleRechargePoints}
            handleRechargeCredits={handleRechargeCredits}
            handlePointsConversion={handlePointsConversion}
            accessToken={accessToken}
            balance={balance}
            handleAlert={handleAlert}
            intervalObservable={intervalObservable}
            handleIntervalObservable={handleIntervalObservable}
            handleDisabledConfirmButton={handleDisabledConfirmButton}
            handleLoadingConfirmButton={handleLoadingConfirmButton}
          />
        )}
      </div>
    </div>
  )
}

Recharge.propTypes = {
  success: PropTypes.bool,
  rechargePoints: PropTypes.number,
  rechargeCredits: PropTypes.number,
  handleRechargePoints: PropTypes.func,
  handleRechargeCredits: PropTypes.func,
  handlePointsConversion: PropTypes.func,
  accessToken: PropTypes.string,
  balance: PropTypes.object,
  handleAlert: PropTypes.func,
  transactionId: PropTypes.string,
  intervalObservable: PropTypes.any,
  handleIntervalObservable: PropTypes.func,
  handleDisabledConfirmButton: PropTypes.func,
  handleLoadingConfirmButton: PropTypes.func
}

export default Recharge



// WEBPACK FOOTER //
// ./src/features/LikePlusCustom/Tabs/Recharge/Recharge.js